export default __webpack_public_path__ + "static/media/goshen84.9095f9e6.jpg";